import React, { useCallback, useEffect, useRef } from "react";
import {
  Card,
  CardContent,
  CircularProgress,
  createStyles,
  makeStyles,
  Typography,
} from "@material-ui/core";
import classNames from "classnames";
import { useLocation } from "react-router-dom";

import { fetchOrder } from "../../helper/Api";
import { errors, getApiError } from "../../helper/Error";
import ErrorDialog from "../common/ErrorDialog";
import { useStateSafe } from "../../helper/customHook";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      margin: theme.spacing(2),
      paddingTop: theme.spacing(3),
    },
    card: {
      padding: theme.spacing(2),
      whiteSpace: "pre-line", // \nで改行用
      width: "100%",
      maxWidth: "600px",
    },
    text: {
      fontSize: 20,
      background:
        "linear-gradient(90deg, rgba(237, 119, 128, 0) 0%, rgba(237, 119, 128, 0) 50%, #fff 0%, #fff 100%), linear-gradient(180deg, rgba(100, 100, 100, 0) 0%, rgba(100, 100, 100, 0) 97.5%, #646464 100%)",
      backgroundSize: "8px 100%,100% 2em",
      lineHeight: "2em",
    },
    loader: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(22),
    },
    nothing: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      whiteSpace: "pre-line",
      fontSize: 22,
      marginTop: theme.spacing(22),
    },
  })
);

export default function Order() {
  const classes = useStyles();
  const location = useLocation();
  const { serviceId } = location.state;
  const [isLoading, setIsLoading] = useStateSafe(true);
  const [data, setData] = useStateSafe([]);

  const errorRef = useRef({});
  const [isOpenError, setIsOpenError] = useStateSafe(false);
  const handleCloseError = useCallback(() => {
    setIsOpenError(false);
  }, [setIsOpenError]);

  useEffect(() => {
    const fn = async () => {
      await fetchOrder(serviceId)
        .then((res) => {
          if (res.data.error.length === 0) setData(res.data.result);
          else throw res.data.error;
        })
        .catch((err) => {
          errorRef.current = err.code
            ? getApiError(err)
            : errors.APP_CONNECTION_FAILED;
          setIsOpenError(true);
        });
      setIsLoading(false);
    };
    fn();
  }, [serviceId, setData, setIsOpenError, setIsLoading]);

  return (
    <>
      {isLoading ? (
        <div className={classes.loader}>
          <CircularProgress />
        </div>
      ) : data.length === 0 || data[0].shiji_note === null ? (
        <Typography color="textSecondary" className={classes.nothing}>
          {"指示事項はありません"}
        </Typography>
      ) : (
        <div className={classes.root}>
          <Card elevation={3} className={classes.card}>
            <CardContent>
              <Typography className={classNames(classes.text, "canSelect")}>
                {data[0].shiji_note}
              </Typography>
            </CardContent>
          </Card>
        </div>
      )}

      <ErrorDialog
        open={isOpenError}
        onClose={handleCloseError}
        error={errorRef.current}
      />
    </>
  );
}
